module.exports = __webpack_public_path__ + "static/media/nike-oranje-fatalis-5.2ba287a8.jpg";